import { defineStore, storeToRefs } from "pinia";
import { objectCountry } from "../helpers/objectCountry";
import { useBrandingStore } from "./brandingStore";
import { useStorageStore } from "./storageStore";

export const useCartStore = defineStore("cart", {
  state: () => ({
    cart: {},
    coords: null,
    error: null,
    isLoading: false,
    watcherId: null
  }),
  getters: {
    tokenCart: (state) => state.cart.token,
    currency: (state) => state.cart.currency,
    country: (state) => objectCountry[state.cart.currency]?.country,
    objectCountry: (state) => objectCountry[state.cart.currency]
  },
  actions: {
    setCart(value) {
      this.cart = value;
      const branding = useBrandingStore();
      const { hasDelivery, hasIdentification } = storeToRefs(branding);
      hasDelivery.value = true;
      hasIdentification.value = true;

      const storage = useStorageStore();
      const { store } = storeToRefs(storage);
      store.value = value;
    }
  },
});
